import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const CustomModal = ({ isOpen, closeModal, data }) => {
    if (!data) {
        return null;
    }
    return (
        <div
            style={{
                background: "#3a94e8",
            }}
        >
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                contentLabel="Modal"
                style={{
                    overlay: {
                        background: "rgba(0, 0, 0, 0.5)",
                    },
                    content: {
                        background: "#e2e9ff",
                        border: "none",
                        borderRadius: "10px",
                        maxWidth: "600px",
                        margin: "0 auto",
                        padding: "30px",
                    },
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "1.5rem",
                        width: "100%",
                    }}
                >
                    <h2
                        style={{
                            fontWeight: "bold",
                            padding: "1rem 2rem",
                            borderRadius: "10px",
                            background: "#3a94e8",
                            color: "white",
                        }}
                    >Date: {data.date}</h2>
                    <p
                        style={{
                            height: "3rem",
                            borderRadius: "10px",
                            fontSize: "30px",
                            fontWeight: "bold",
                            padding: "1rem 3rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#e6b219",
                            color: "white",
                            boxShadow: "0px 0px 5px 0px #607d8b",
                            margin: "1rem",
                            width: "80%"
                        }}
                    >Total Points: {data.totalPoints}</p>
                    <p
                        style={{
                            height: "3rem",
                            borderRadius: "10px",
                            fontSize: "30px",
                            fontWeight: "bold",
                            padding: "1rem 3rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#78335d",
                            color: "white",
                            boxShadow: "0px 0px 5px 0px #607d8b",
                            margin: "1rem",
                            width: "80%"
                        }}
                    >Easy Points: {data.easy}</p>
                    <p
                        style={{
                            height: "3rem",
                            borderRadius: "10px",
                            fontSize: "30px",
                            fontWeight: "bold",
                            padding: "1rem 3rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#e6196e",
                            color: "white",
                            boxShadow: "0px 0px 5px 0px #607d8b",
                            margin: "1rem",
                            width: "80%"
                        }}
                    >Medium Points: {data.medium}</p>
                    <p
                        style={{
                            height: "3rem",
                            borderRadius: "10px",
                            fontSize: "30px",
                            fontWeight: "bold",
                            padding: "1rem 3rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#20a65e",
                            color: "white",
                            boxShadow: "0px 0px 5px 0px #607d8b",
                            margin: "1rem",
                            width: "80%"
                        }}
                    >Hard Points: {data.hard}</p>
                    <button
                        style={{
                            background: "#007bff",
                            color: "#fff",
                            padding: "12px 20px",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease-in-out, transform 0.2s ease-in-out",
                            fontSize: "16px",
                            fontWeight: "bold",
                            display: "block",
                            margin: "20px auto 0",
                        }}
                        onClick={closeModal}
                    >
                        Close
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default CustomModal;
